import axios from 'axios';
document.addEventListener('turbolinks:load', () => {

  $("#sale_parent_area").change(function() {
    var p = $("#sale_parent_area option:selected").val();
    console.log(p)
    const queries = {
      team_id: gon.team_id,
      label: p
    }

    $('#sale_child_area option').remove();
    check3_reload(queries, -1);

  })

  async function check3_reload(queries, child_tag_id){
    const url = process.env.ROOT_DIR + "tag_relations/get_categories";
    axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
    // console.log(url)
    const data = await axios.get(url,
      {params: queries}
      ).then((response)=>{return response.data.data}
    )
    // console.log(data)
    var item_selectbox = document.getElementById("sale_child_area")
    
    if(data.length === 0){
      let op = document.createElement("option");
      op.value = 0;
      op.text = "勘定科目を選択してください";

      item_selectbox.appendChild(op);
    }else{
      let op = document.createElement("option");
      op.value = 0;
      op.text = "選択してください";

      item_selectbox.appendChild(op);
      for(var i = 0;i < data.length;i++){
        var seed = {val: data[i].id, txt: data[i].name};
        let op = document.createElement("option");
        op.value = Number(seed.val);
        op.text = seed.txt;
        if(child_tag_id === -1){
          if(i === 0){
            op.selected = true;
          }
        }else{
          if(Number(seed.val) === child_tag_id){
            op.selected = true;
          }
        }
        item_selectbox.appendChild(op);
      }
    }
  }

  $('#sale_auto_input').change(function(){


    var clipno = $("#sale_auto_input option:selected").val();
    // console.log(clipno === "")
    if(clipno === ""){
      
      $("#sale_purpose_input").val("");
      $("#sale_autoComplete").val("");
      $("#sale_price_input").val("");
      document.getElementById("sale_price_input").checked = false;

      $("#sale_excused_at_input").val("");
      $("#sale_completed_at_input").val("");
      $("#sale_parent_area").val("");

      $('#sale_child_area option').remove();
      let op = document.createElement("option");
      op.value = 0;
      op.text = "勘定科目を選択してください";
      document.getElementById("sale_child_area").appendChild(op);

      $("#sale_memo_input").val("");

    }else{
      var result = gon.clip_sales.find((c) => c.id == clipno);

      $("#sale_purpose_input").val(result.purpose);
      $("#sale_autoComplete").val(result.customer_name);
      $("#sale_price_input").val(result.price);
      if(result.cash === 1){
        document.getElementById("sale_cash_checked").checked = true;
      }else{
        document.getElementById("sale_cash_checked").checked = false;
      }
      // $("#sale_excused_at_input").val(result.excuted_at);
      // $("#sale_completed_at_input").val(result.completed_at);
      $("#sale_parent_area").val(result.parent_tag_id);

      const queries = {
        team_id: gon.team_id,
        label: result.parent_tag_id
      }
  
      $('#sale_child_area option').remove();
      check3_reload(queries, Number(result.child_tag_id));
      $("#sale_memo_input").val(result.memo);
    }

  })

  

  // $('#in_out_select').change(function() {
  //   in_out_select_reload();
  // });

  // $('#group_area').change(function() {
  //   group_select_reload();
  // });

  // $('#item_area').change(function() {
  //   item_select_reload();
  // });


  // function in_out_select_reload(){
  //   la_0 = gon.g_0;
  //   la_1 = gon.g_1;

  //   var o = $("#in_out_select option:selected").text();
  //   $("#in_out_select_span").text(o);

  //   $('#group_area option').remove();
  //   // console.log($("#in_out_select option:selected").val());
  //   if (o === "収入"){
  //     la = la_0;
  //   }else{
  //     la = la_1;
  //   }

  //   for(var i = 0; i < la.length ;i++ ){
  //     var zokusei_1 = {val: la[i].label, txt: la[i].name};

  //     let op_1 = document.createElement("option");
  //     op_1.value = zokusei_1.val;  //value値
  //     op_1.text = zokusei_1.txt;   //テキスト値
  //     document.getElementById("group_area").appendChild(op_1);
  //   }
  //   group_select_reload();
  // }

  // function group_select_reload(){
  //   la = gon.inilabel;

  //   var r = $("#group_area option:selected").val();
  //   var r_1 = $("#group_area option:selected").text(); 
  //   $("#group_area_span").text(r +". "+ r_1);
  //   $('#item_area option').remove();
  //   for(var i = 0; i < la.length ;i++ ){
  //     if(la[i][0] === r){
  //       for(var j = 0; j < la[i][1].length ;j++ ){
  //         var zokusei = {val: la[i][1][j].number, txt: la[i][1][j].name};
  //         let op = document.createElement("option");
  //         op.value = zokusei.val;  //value値
  //         op.text = zokusei.txt;   //テキスト値
  //         document.getElementById("item_area").appendChild(op);
  //       }
  //     }
  //   }
  //   item_select_reload();
  // }

  // function item_select_reload(){
  //   var p = $("#item_area option:selected").val();
  //   var p_1 = $("#item_area option:selected").text();
  //   $("#item_area_span").text(p +". "+ p_1);
  // }

  // $('#customer_input').change(function() {
  //   var s = $("#customer_input").val();

  //   customer_name_flag = false;
  //   for(var i = 0 ; i < gon.sale_customer_unique.length ; i++){
  //     if (gon.sale_customer_unique[i].customer_name === s){
  //       customer_name_flag = true;
  //     }
  //   }
  //   if(customer_name_flag === true){
  //     $("#customer_area_span").css("color", "black");
  //     var caution = "登録されている名前です。";
  //   }else{
  //     $("#customer_area_span").css("color", "red");
  //     var caution = "登録されていません。新規登録となります。";
  //   }
  //   $("#customer_area_span").text(caution);
  // });


  // $('#group_history').click(function(){

  //   var this_id = gon.this_team_id
  //   console.log(this_id)
  //   $.ajax({
  //     url: "/clips/" + this_id + "/getfav",
  //     dataType: 'json',
  //     contentType: 'application/json',
  //     type: 'GET',
  //     data: JSON.stringify({
  //     }),
  //     beforeSend: function(xhr) {
  //       xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
  //     },
  //     cache: false
  //   }).then((response) => {

  //     var foodMenu = response;
  //     let menuList = document.getElementById('group_history');
  //     menuList.innerHTML = '';
      
  //     let option = document.createElement('option');
  //     option.innerHTML = '料理を選択してください';
  //     option.defaultSelected = true;
  //     option.disabled = true;
  //     menuList.appendChild(option);  

  //     foodMenu["japaneseFoods"].forEach( menu => {
  //       let option = document.createElement('option');
  //       option.innerHTML = menu.name;
  //       option.value = menu.value;
  //       menuList.appendChild(option);  
  //     });
  //   });
  // });

  // $('#group_history').change(function(){
  //   console.log($(this).val())
  // });


  // $('#group_auto_input').change(function(){

  //   clipno = $("#group_auto_input option:selected").val();
  //   var result = gon.transposed_clipped_posts_info.indexOf(Number(clipno));
  //   var target = gon.clipped_posts_info[result];

  //   // console.log(result);

  //   if(result !== -1){

  //     // if(target[3] === 0){
  //     //   document.getElementById("in_out_select").selectedIndex = 0
  //     //   $("#in_out_select_span").text("収入");
  //     // }else{
  //     //   document.getElementById("in_out_select").selectedIndex = 1
  //     //   $("#in_out_select_span").text("支出");
  //     // }
      
  //     $("#customer_input").val(target[1]);
  //     $("#price_input").val(target[5]);
        
  //     if(target[7] == true){
  //       document.getElementById("cash_checked").checked = true;
  //     }else{
  //       document.getElementById("cash_checked").checked = false;
  //     }
  //     $("#excused_input").val(target[8]);

  //     $("#group_area").val(target[6]);
  //     var r = $("#group_area option:selected").val();
  //     var r_1 = $("#group_area option:selected").text(); 
  //     $("#group_area_span").text(r +". "+ r_1);

  //     $("#item_area").val(target[9]);
  //     item_select_reload();

  //     $("#purpose_input").val(target[2]);
  //     $("#memo_input").val(target[4]);

  //   }else{
  //     $("#purpose_input").val("");
  //     $("#memo_input").val("");
  //     $("#customer_input").val("");
  //     $("#price_input").val("");
  //   }
  // })


// // sale
//   $('#sale_group_area').change(function() {
//     sale_group_select_reload();
//   });

//   $('#sale_area').change(function() {
//     sale_select_reload();
//   });

//   function sale_group_select_reload(){
//     la = gon.inilabel;

//     var r = $("#sale_group_area option:selected").val();
//     var r_1 = $("#sale_group_area option:selected").text(); 
//     $("#sale_group_area_span").text(r +". "+ r_1);
//     $('#sale_area option').remove();
//     for(var i = 0; i < la.length ;i++ ){
//       if(la[i][0] === r){
//         for(var j = 0; j < la[i][1].length ;j++ ){
//           var zokusei = {val: la[i][1][j].number, txt: la[i][1][j].name};
//           let op = document.createElement("option");
//           op.value = zokusei.val;  //value値
//           op.text = zokusei.txt;   //テキスト値
//           document.getElementById("sale_area").appendChild(op);
//         }
//       }
//     }
//     sale_select_reload();
//   }

//   function sale_select_reload(){
//     var p = $("#sale_area option:selected").val();
//     var p_1 = $("#sale_area option:selected").text();
//     $("#sale_area_span").text(p +". "+ p_1);
//   }

//   $('#sale_customer_input').change(function() {
//     var s = $("#sale_customer_input").val();

//     customer_name_flag = false;
//     for(var i = 0 ; i < gon.customer_unique.length ; i++){
//       if (gon.customer_unique[i].customer_name === s){
//         customer_name_flag = true;
//       }
//     }
//     if(customer_name_flag === true){
//       $("#sale_customer_area_span").css("color", "black");
//       var caution = "登録されている名前です。";
//     }else{
//       $("#sale_customer_area_span").css("color", "red");
//       var caution = "登録されていません。新規登録となります。";
//     }
//     $("#sale_customer_area_span").text(caution);
//   });



})